import { InjectionToken } from "../di/index.js";
export const PulseRootConfigurationToken = new InjectionToken('PULSE_ROOT_CONFIGURATION');
//# sourceMappingURL=tokens.js.map